<template>
    <div id="app">
      <template v-if="$route.meta.template==1">
        <router-view></router-view>
      </template>

      <template v-if="$route.meta.template==2">
        <div class="sub_index">
          <div :class="'sub_index_left '+menuClass">
            <div class="left-bar-warp">
              <div @click="hideMenu" class="menu_hide"> < </div>
              <MainMenu></MainMenu>
            </div>
          </div>
          <div class="sub_index_right">
            <img class="hamburger" @click="showMenu" src="../src/assets/images/menu_hamburger.png" />
            <div class="sub_index_content">
              <router-view></router-view>
            </div>
            <div class="notice" v-html="$route.meta.notice"></div>
          </div>
        </div>
      </template>

      <template v-if="$route.meta.template==3">
        <div class="sub_index">
          <div :class="'sub_index_left '+menuClass">
            <div class="left-bar-warp">
              <div @click="hideMenu" class="menu_hide"> < </div>
              <MainMenu></MainMenu>
            </div>
          </div>
          <div class="sub_page_right">
            <img class="hamburger" @click="showMenu" src="../src/assets/images/menu_hamburger.png" />
            <div class="sub_page">
              <div class="sub_header">
                <h1 v-html="$route.meta.sub_header"></h1>
              </div>
              <router-view></router-view>
            </div>
          </div>
        </div>
      </template>

<!--   课时7页面模板-->
      <template v-if="$route.meta.template==4">
        <div class="sub_index">
          <div :class="'sub_index_left '+menuClass">
            <div class="left-bar-warp">
              <div @click="hideMenu" class="menu_hide"> < </div>
              <MainMenu></MainMenu>
            </div>
          </div>
          <div class="sub_index_right sub_index_right_7">
            <img class="hamburger" @click="showMenu" src="../src/assets/images/menu_hamburger.png" />
            <div class="sub_index_content">
              <img class="logo" src="../src/assets/images/logo.png" />
              <router-view></router-view>

            </div>
            <div class="notice-7">
              <p><span>*Use with caution in patients with CrCl of 15–29 mL/min. Contraindicated in patients with CrCl <15 mL/min.</span></p>
              <p>AF, atrial fibrillation; CrCI, creatinine clearance; DVT, Deep vein thrombosis; NOAC, non-vitamin K oral anticoagulant; NVAF, nonvalvular atrial fibrillation; OD, once daily; PE, pulmonary embolism; TGA, Therapeutic Goods Administration; VKA, vitamin K antagonists.</p>
              <p><span>1.</span> Xarelto (rivaroxaban) Product Information. 02 Jun 2020 <span>2.</span> Eliquis (apixaban) Product Information. 23 Jun 2020. <span>3.</span> Pradaxa (dabigatran) Product Information. 15 Mar 2021. <span>4.</span> Van Gorp RH, Schurgers LJ. <i>Nutrients</i> 2015;7:9538–9557; <span>5.</span> Willems BAG <i>et al. Mol Nutr Food Res</i> 2014;58:1620–1635. <span>6.</span> Yao X <i>et al. J Am Coll Cardiol</i> 2017;70:2621–2632. <span>7.</span> January CT <i>et al. Circulation</i> 2019 Jul 9;140(2):e125-e151. <span>8.</span> Halperin JL <i>et al. Circulation</i> 2014;130:138–146. <span>9.</span> Hanon O et al. Heart 2020; doi: 10 .1136/heartjnl-2020-317923.</p>
            </div>
          </div>
        </div>

      </template>

      <footer>
        <div class="footer-area">
          <p>Bayer is required to comply with the Australian Privacy Act 1988 (Cth) (“Privacy Act”). Our privacy policy sets out how Bayer seeks to ensure that any personal information we hold about you is collected, used, stored and disclosed in accordance with the Australian Privacy Principles in the Privacy Act. To know more about how we collect your data, <a target="_blank" href="https://kidneyheartprotect.com.au/privacy-policy.pdf">click here</a> </p>
          <p>©2026, Bayer Inc. All rights reserved. Bayer Australia Ltd, ABN 22 000 138 714, 875 Pacific Highway, Pymble, NSW 2073. </p>
          <p>®Registered trademark of the Bayer Group, Germany. PP-KER-AU-0305-2. KER-05007-03. Date of preparation: April 2026.</p>
        </div>
      </footer>
    </div>
</template>

<script>
import MainMenu from "./components/MainMenu";
export default {
    name: 'App',
  components: {MainMenu},
  data() {
        return {
            title:"",
            projectName:process.env.VUE_APP_TITLE,
            menuClass:"",
        }
    },
    mounted() {

    },

    methods: {
        setTitle(title){
          this.title = title;
        },
      showMenu(){
          this.menuClass = 'show';
      },
      hideMenu(){
        this.menuClass = '';
      },

    },
    computed:{

    }

}
</script>
@import url("https://fonts.googleapis.com/css2?family=Open+Sans:wght@300;400;600;700&display=swap");
